import { h, JSX } from 'preact'
import { ToggleButtonCustomElementName } from './custom-element'
import { useEffect, useRef } from 'preact/hooks'

export interface ExpandButtonProps extends JSX.HTMLAttributes {
  selector: string
  classToToggle: string
  classWhenToggling?: string
  isCustomElementDisabled?: boolean
}

export function ToggleButtonComponent(props: ExpandButtonProps) {
  const { classToToggle, classWhenToggling, isCustomElementDisabled, selector, ...rest } = props

  const ref = useRef<HTMLElement>()

  return h(ToggleButtonCustomElementName, {
    ref,
    'class-to-toggle': classToToggle,
    'class-when-toggling': classWhenToggling,
    role: 'button',
    selector: selector,
    ...rest
  })
}
